import { render, staticRenderFns } from "./DBPDisclamer.vue?vue&type=template&id=2c1fd186&scoped=true&lang=pug&"
import script from "./DBPDisclamer.vue?vue&type=script&lang=ts&"
export * from "./DBPDisclamer.vue?vue&type=script&lang=ts&"
import style0 from "./DBPDisclamer.vue?vue&type=style&index=0&id=2c1fd186&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1fd186",
  null
  
)

export default component.exports